export interface TaskCategory {
  type: number,
  name: string,
  tasks: string[],
}

export const TaskCategoryTypes: any = {
  ALL: 0,
  TEXT_COMP: 1,
  VOCAB: 2,
  DECODING: 3,
  RECOG: 4,
  SPELLING: 5,
  SYLLABLE: 6,
  SPEEDED: 7,
  ENCODING: 8,
  MORPH: 9,
}

export const TaskCategories: TaskCategory[] = [
  {
    type: TaskCategoryTypes.ALL,
    name: 'All',
    tasks: [

    ],
  },
  {
    type: TaskCategoryTypes.DECODING,
    name: 'Decoding/Basic Encoding',
    tasks: [
      'FB',
      'FWF',
      'CHW',
    ],
  },
  {
    type: TaskCategoryTypes.SYLLABLE,
    name: 'Syllable Knowledge',
    tasks: [
      'MTW',
      'FSU',
      'FSA',
      'FSB',
    ],
  },
  {
    type: TaskCategoryTypes.RECOG,
    name: 'Word Recognition',
    tasks: [
      'FTW',
      'RHY',
      'FWF',
      'PIC',
    ],
  },
  {
    type: TaskCategoryTypes.SPEEDED,
    name: 'Speeded Word Recognition',
    tasks: [
      'RHYM',
      'PICM',
      'FSM',
    ],
  },
  {
    type: TaskCategoryTypes.SPELLING,
    name: 'Spelling',
    tasks: [
      'STW',
      'SPELL',
    ],
  },
  {
    type: TaskCategoryTypes.VOCAB,
    name: 'Vocabulary',
    tasks: [
      'PAP',
      'PIC',
      'CTM',
    ],
  },
  {
    type: TaskCategoryTypes.MORPH,
    name: 'Morphology',
    tasks: [
      'CTM',
    ],
  },
  {
    type: TaskCategoryTypes.TEXT_COMP,
    name: 'Text Comprehension',
    tasks: [
      'PAQ',
      'FTP',
    ],
  },
  {
    type: TaskCategoryTypes.ENCODING,
    name: 'All Encoding',
    tasks: [
      'STW',
      'SPELL',
      'MTW',
      'MTP',
    ],
  },
]
